import { createSlice } from "@reduxjs/toolkit";
import { getDocs, collection } from "firebase/firestore";
import { db } from "../config/firebase";

const initialState = {
  accommodations: [],
  events: [],
  restaurants: [],
  malls: [],
  buses: [],
  attractionsites: [],
  loading: false,
  error: null,
};

export const counterSlice = createSlice({
  name: "db",
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setData(state, action) {
      const { collectionName, data } = action.payload;
      state[collectionName] = data;
      state.loading = false;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const { setLoading, setError, setData } = counterSlice.actions;

export default counterSlice.reducer;

export const fetchData = (collectionName) => async (dispatch) => {
  dispatch(setLoading());

  try {
    const querySnapshot = await getDocs(collection(db, collectionName));
    const data = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    dispatch(setData({ collectionName, data }));
  } catch (error) {
    dispatch(setError(error.message));
  }
};

export const fetchAccommodations = () => fetchData("accommodations");
export const fetchEvents = () => fetchData("events");
export const fetchMalls = () => fetchData("malls");
export const fetchResturants = () => fetchData("restaurants");
export const fetchAttractionsites = () => fetchData("attractionsites");
export const fetchBuses = () => fetchData("buses");

